<template>
	<div class="questionBankAnalysis">
		<div class="QuestionBankList">
			<div class="list">
				<div class="header-box">
					<div class="myBank-box">
						<span class="myBank-title">{{$t('QuesLibrary.SelfBuiltQuestionBank')}}</span>
						<span :title="$t('QuesLibrary.Refresh')" @click="getBankApi(0)" class="el-icon-refresh-right icon"></span>
					</div>
				</div>
				<el-menu class="el-menu-vertical-demo" @open="myOptionsOpen" @close="myOptionsOpen">
					<template v-if="myOptions.length > 0">
						<el-submenu class="Level2" v-for="(item, index) in myOptions" :key="item.id" :index="`${item.value}-${index}`">
							<template slot="title">
								<span :class="actionBid == item.value ? 'bgTrueColor' : 'bgFalseColor'">{{ item.label }}</span>
							</template>
							<!-- <el-menu-item v-for="info in item.questionsList" :key="info.id" @click="addQuestion(info)" class="ellipsis1">
								{{ $functions.htmlFormat(info.questionsName) }}
							</el-menu-item> -->
						</el-submenu>
					</template>
					<div v-else class="null">{{$t('main.ThereIsCurrentlyNoContentAvailable')}}</div>
				</el-menu>
			</div>
			<div class="list">
				<div class="header-box"><span>{{$t('QuesLibrary.BankSoalanSistem')}}</span></div>
				<el-menu class="el-menu-vertical-demo" @open="systemOptionsOpen">
					<template v-if="systemOptions.length > 0">
						<el-submenu class="Level2" v-for="(item, index) in systemOptions" :key="item.id" :index="`1-${item.value}-${index}`">
							<template slot="title">
								<span :class="actionBid == item.value ? 'bgTrueColor' : 'bgFalseColor'">{{ item.label }}</span>
							</template>
							<!-- 	<el-menu-item v-for="(info, i) in item.questionsList" :key="info.id" :index="`1-${index + 1}-${i + 1}`" @click="addQuestion(info)">
								{{ $functions.htmlFormat(info.questionsName) }}
							</el-menu-item> -->
						</el-submenu>
					</template>
					<div v-else class="null">{{$t('main.ThereIsCurrentlyNoContentAvailable')}}</div>
				</el-menu>
			</div>
		</div>
		<div class="statistics">
			<ItemStatistics ref="ItemStatistics" :questionBankId="actionBid">
			
			</ItemStatistics></div>
	</div>
</template>

<script>
import Paper from '@/page/myQuestionnaire/js/Paper.js';
import ItemStatistics from '@/page/management/ItemStatistics.vue';
export default {
	name: 'questionBankAnalysis',
	components: {
		ItemStatistics
	},
	props: {
		typeObj: {
			type: Object,
			default: () => {
				return {};
			}
		},
		collapseVisible: {
			type: Array,
			default: () => {
				return [];
			}
		},
		bankType: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			myOptions: [],
			systemOptions: [],
			form: {
				bankName: ''
			},
			addVisible: false,
			paper: {
				questionsList: []
			},
			manageVisible: false,
			manageBankList: [],
			bankQuestionsList: [],
			actionBid: ''
		};
	},
	created() {
		this.getBankOptions();
	},
	methods: {
		handleClose() {
			this.getBankApi(0);
			this.manageVisible = false;
		},
		// 确认重命名
		confirmRenameBlur(item) {
			this.UpdateBank(item);
		},
		// 重命名接口
		UpdateBank(item) {
			let data = {
				name: item.name,
				id: item.id,
				isSystemBank: 0, // 是否系统题库
				bankType: 1 // 0考试 1问卷
			};
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankUpdate}`,
				method: 'POST',
				data: data,
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						item.isRename = false;
						that.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		editBank(e, item) {
			console.log(item.id);
			if (e == 'a') {
				// 重命名
				item.isRename = true;
			} else {
				// 删除
				this.$confirm(this.$t('QuesLibrary.DeleteTitleTip'), this.$t('QuesLibrary.DeleteConfirmation'), {
					confirmButtonText: this.$t('main.ok'),
					cancelButtonText: this.$t('main.cancel')
				})
					.then(() => {
						let arr = [item.id];
						arr.push(item.id);
						this.saveMyDelApi(arr);
					})
					.catch(() => {});
			}
		},
		// 删除题库
		saveMyDelApi(ids) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankDel}?ids=${ids}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						that.getBankApi(0);
						that.$message({
							message: res.message,
							type: 'success'
						});
						that.paper.questionsList.forEach((info, index) => {
							if (index == 0 && ids.indexOf(info.bqid) != -1) {
								that.paper.questionsList = [];
							}
						});
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		toManageBank() {
			this.manageVisible = true;
			this.getBankApi(0);
		},
		addBank(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					let data = {
						isSystemBank: 0, // 我的题库
						name: this.form.bankName,
						type: this.$t('main.Unclassified'),
						bankType: 1 // 0考试 1问卷
					};
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.examBankSave}`,
						method: 'POST',
						data: data,
						cb(res) {
							console.log(res);
							if (res.code == '0') {
								that.setPaperJson(res.message);
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		setPaperJson(id) {
			let paper = new Paper();
			let that = this;
			let data = {
				id: id,
				paperjson: JSON.stringify(paper),
				bankType: 1
			};
			let params = {
				that: this,
				url: `${this.$config.service.examBankAddQuess}`,
				method: 'post',
				data: data,
				cb(res) {
					if (res.code == '0') {
						that.getBankApi(0);
						that.cancelaAddBank('form');
						that.$message({
							message: that.$t('main.AddedSuccessfully'),
							type: 'success'
						});
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		myOptionsOpen(e) {
			this.actionBid  =''
			console.log(e);
			let arr = e.split('-');
			let obj = {
				arr: this.myOptions,
				bid: arr[0],
				i: arr[1]
			};
			this.actionBid = arr[0];
			
			this.$refs.ItemStatistics.loadTj(this.actionBid);
			this.getQuestion(obj);
		},
		systemOptionsOpen(e) {
			console.log(e);
			this.actionBid  =''
			let arr = e.split('-');
			let obj = {
				arr: this.systemOptions,
				bid: arr[1],
				i: arr[2]
			};
			this.actionBid = arr[1];
			this.$refs.ItemStatistics.loadTj(this.actionBid );
			this.getQuestion(obj);
		},
		toGetQuestion(bid) {
			if (bid) this.actionBid = bid;
			this.getQuestion({ bid: this.actionBid });
		},
		getQuestion(obj) {
			if (obj.arr) {
				if (!obj.arr.questionsList) {
					this.$set(obj.arr[obj.i], 'questionsList', []);
				} else {
					obj.arr.questionsList = [];
				}
			}
			let that = this;
			let data = this.$qs.stringify({
				bankId: obj.bid, // 0自建题库 1系统题库
				difficulty: '',
				pageIndex: 1,
				pageSize: 10000,
				type: '', // 题库类别
				isDel: 0, // 是否为回收站列表
				bankType: 1 // 是否为0考试 1问卷
			});
			let params = {
				that: this,
				url: `${this.$config.service.examBankQuesList}?${data}`,
				method: 'GET',
				cb(res) {
					console.log(res);
					if (res.code == '0') {
						let list = [];
						res.resultBody.datas.forEach((info, index) => {
							let quesJson = JSON.parse(info.quesJson);
							quesJson.bqid = info.id;
							list.push(quesJson);
						});
						if (obj.arr) {
							obj.arr[obj.i].questionsList = [...list];
						} else {
							that.paper.questionsList = [...list];
							// console.log(that.paper.questionsList);
						}
					}
				}
			};
			this.$util.request(params);
		},
		addQuestion(e) {
			this.$emit('quesFormBand', e);
		},
		getBankOptions() {
			this.getBankApi(0);
			this.getBankApi(1);
		},
		getBankApi(isSystem) {
			let that = this;
			let data = this.$qs.stringify({
				isSystem: isSystem, // 0自建题库 1系统题库
				pageIndex: 1,
				pageSize: 10000,
				bankType: 1 // 0考试题库 1问卷题库
			});
			let params = {
				that: this,
				url: `${this.$config.service.examBankList}?${data}`,
				method: 'GET',
				cb(res) {
					console.log('初始化1111',res);
					if (res.code == '0') {
						if (isSystem == 0) {
							that.myOptions = [];
							res.resultBody.datas.forEach((info, index) => {
								if (index == 0) {
									that.actionBid = info.id;
									that.getQuestion({ bid: info.id });
								}
								that.myOptions.push({
									label: info.name,
									value: info.id
								});
								that.$set(info, 'isRename', false);
								// console.log(that.myOptions)
							});
							that.manageBankList = [...res.resultBody.datas];
							if (that.actionBid != '') {
								that.$refs.ItemStatistics.loadTj(that.actionBid);
							}
						} else {
							that.systemOptions = [];
							res.resultBody.datas.forEach((info, index) => {
								if (index == 0) {
									// that.actionBid = info.id;
									that.getQuestion({ bid: info.id });
								}
								that.systemOptions.push({
									label: info.name,
									value: info.id
								});
							});
							// if (that.actionBid != '') {
							// 	that.$refs.ItemStatistics.loadTj(that.actionBid);
							// }
						}
					} else {
						if (isSystem == 0) {
							that.myOptions = [];
							that.manageBankList = [];
						} else {
							that.systemOptions = [];
						}
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style lang="scss" scoped>
.bgTrueColor {
	background-color: #0080ff;
	color: #ffffff;
	padding-left: 5px;
}
.bgFalseColor{
	color: #303133;;
	padding-left: 5px;
}
.null {
	text-align: center;
	font-size: 12px;
	height: 150px;
	line-height: 150px;
	color: #ccc;
}
/deep/.el-submenu__icon-arrow {
	display: none;
}
.questionBankAnalysis {
	display: flex;
	width: 100%;
	height: 100%;
	.QuestionBankList {
		height: 100%;
		width: 190px;
		padding: 14px;
		.header-box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 10px;
			height: 40px;
			border-bottom: solid 1px #e6e6e6;
			.myBank-box {
				.icon {
					font-size: 12px;
					color: #a7a6a6;
					margin-left: 10px;
					cursor: pointer;
				}
			}
		}
		.list + .list {
			margin-top: 15px;
			border-top: solid 1px #e6e6e6;
		}

		/deep/.el-submenu .el-menu-item,
		/deep/.el-submenu__title {
			height: 26px;
			line-height: 26px;
		}
		/deep/.el-menu {
			border-right: 0px;
			// border-top: solid 1px #e6e6e6;
			// border-bottom: solid 1px #e6e6e6;
			// padding: 10px 0;
			// margin-bottom: 15px;
			.el-menu-item.is-active {
				color: #000;
			}
		}
	}
	.statistics {
		flex: 1;
		height: 100%;
		background-color: rgb(245, 245, 245);
	}
}
.el-submenu__title span {
	display: inline-block;
	width: 80%;
}
.el-menu-item {
	width: 100%;
}
.el-submenu__title span,
.el-menu-item {
	/* 下拉框文字 超出隐藏 */
	white-space: nowrap;
	-webkit-box-flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
}
</style>
<style lang="scss">
.item_container {
	margin: 10px !important;
	border: 1px solid #eaeaea;
	border-radius: 5px;
}
</style>
